module.exports = __webpack_public_path__ + "img/telegram.4f61bed2.png";